import React from 'react'
import * as PropTypes from 'prop-types'
import Modal from '../Modal/Modal'

import './ErrorModal.scss'

const errorMessages = {
  R: 'We’re sorry. The selected ship and sail date is not currently supported through the My Royal Cruise platform. Please check back at a later date.',
  C: 'We’re sorry. The selected ship and sail date is not currently supported through the My Celebrity Cruise platform. Please check back at a later date.',
}

const brandClasses = {
  R: 'royal',
  C: 'celebrity',
}

const ErrorModal = ({ isOpen, onRequestClose, brandCode }) => {
  const messageClass = `error-message ${brandClasses[brandCode]}`
  const buttonClass = `btn btn-close ${brandClasses[brandCode]}`

  return (
    <Modal
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      className="error-modal"
      overlayClassName="error-modal-overlay"
    >
      <div className="error-modal-content u-text-center">
        <div className={messageClass}>{errorMessages[brandCode]}</div>
        <button className={buttonClass} onClick={onRequestClose}>
          Close
        </button>
      </div>
    </Modal>
  )
}

ErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  brandCode: PropTypes.string.isRequired,
}

export default ErrorModal
